/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductRegisterSkuResult
 */
export interface ProductRegisterSkuResult {
    /**
     * SKU编码
     * @type {string}
     * @memberof ProductRegisterSkuResult
     */
    skuCode?: string;
    /**
     * 条形码编号
     * @type {string}
     * @memberof ProductRegisterSkuResult
     */
    marketBarcode?: string;
    /**
     * 条形码商品名称
     * @type {string}
     * @memberof ProductRegisterSkuResult
     */
    marketProNm?: string;
    /**
     * 平均成本
     * @type {number}
     * @memberof ProductRegisterSkuResult
     */
    avgCost?: number;
    /**
     * SKU类型：1-单一，2-组合
     * @type {number}
     * @memberof ProductRegisterSkuResult
     */
    skuType?: number;
    /**
     * 商品总数
     * @type {number}
     * @memberof ProductRegisterSkuResult
     */
    productCount?: number;
}

/**
 * Check if a given object implements the ProductRegisterSkuResult interface.
 */
export function instanceOfProductRegisterSkuResult(value: object): value is ProductRegisterSkuResult {
    return true;
}

export function ProductRegisterSkuResultFromJSON(json: any): ProductRegisterSkuResult {
    return ProductRegisterSkuResultFromJSONTyped(json, false);
}

export function ProductRegisterSkuResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRegisterSkuResult {
    if (json == null) {
        return json;
    }
    return {
        
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'avgCost': json['avgCost'] == null ? undefined : json['avgCost'],
        'skuType': json['skuType'] == null ? undefined : json['skuType'],
        'productCount': json['productCount'] == null ? undefined : json['productCount'],
    };
}

export function ProductRegisterSkuResultToJSON(json: any): ProductRegisterSkuResult {
    return ProductRegisterSkuResultToJSONTyped(json, false);
}

export function ProductRegisterSkuResultToJSONTyped(value?: ProductRegisterSkuResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuCode': value['skuCode'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'avgCost': value['avgCost'],
        'skuType': value['skuType'],
        'productCount': value['productCount'],
    };
}

